import { call, put, takeEvery } from 'redux-saga/effects'

import api from 'services/api'

import {
	getDatabaseTexts,
	getDatabaseTextsSuccess,
	getDatabaseTextsFailure,
} from '.'

export default function* rootSaga() {
	yield takeEvery(getDatabaseTexts, getDatabaseTextsSaga)
}

function* getDatabaseTextsSaga({ payload = {} }) {
	const { id, perPage = 100, page = 1 } = payload

	try {
		const { data } = yield call(
			api.get,
			`/textdb/${id}/textitems?page=${page}&per_page=${perPage}`
		)

		yield put(getDatabaseTextsSuccess({ ...data, id }))
	} catch (error) {
		yield put(getDatabaseTextsFailure({ error, id }))
	}
}
